// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { actions as ProductListActions } from '../duck';
import ProductList from '../components/ProductList';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    productList: state.productList.productList,
    isFetchingProductList: state.productList.isFetchingProductList,
    locale: state.locale,
    localValues: state.localValues,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...ProductListActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductList);



// WEBPACK FOOTER //
// ./src/modules/product-list/containers/ProductListContainer.jsx